<template>
  <v-dialog
    v-model="refundDialog"
    width="800px"
  >
    <template v-slot:activator="{ on }">
      <v-btn small class="text-none" v-on="on">Refund Cancellation Fee</v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Refund Trip</span>
      </v-card-title>
      <v-layout column px-4>
        <v-currency-field
          type="number"
          v-bind="currency_config"
          v-model="amount"
          min="0"
          class="small-text-field"
          :value="bookingForm.booking.final_cost"
          single-line
          height="28"
          flat
        ></v-currency-field>
        <v-text-field v-model="reason" label="Reason for Refund"></v-text-field>
        <p style="color:red;" v-if="refundError != null">{{ refundError }}</p>
      </v-layout>
      <v-card-actions v-if="loadingRefund == false">
        <v-spacer></v-spacer>
        <v-btn flat text @click="refundDialog = false">Cancel</v-btn>
        <v-btn flat text @click="refundTrip()">Give Refund</v-btn>
      </v-card-actions>
      <v-progress-linear v-if="loadingRefund == true" indeterminate color="yellow darken-2"></v-progress-linear>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";

import qs from "qs";
import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  name: "StripeRefund",
  mounted: function() {},
  components: {},
  props: {
    bookingForm: Object
  },
  data: function() {
    return {
      loadingRefund: false,
      refundDialog: false,
      refundError: null,
      currency_config: {
        decimal: ".",
        prefix: "£",
        precision: 2,
        masked: false,
        allowBlank: true
      },
      reason: null,
      amount: 0
    };
  },
  methods: {
    refundTrip: async function() {
      console.log("Refunding booking");

      this.refundError = null;

      if (this.amount == null || this.amount <= 0) {
        this.refundError = "Please enter an amount more than £0 for the refund";
        return;
      }

      if (this.reason == null || this.reason.length == 0) {
        this.refundError = "Please enter a reason for the refund";
        return;
      }

      this.loadingRefund = true;

      try {
        let response = await axios.post(
          `${this.$store.state.apiUrl}/booking/refundCancellation?booking_id=${
            this.bookingForm.booking.id
          }&amount=${Math.round(
            this.amount * 100
          )}`,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        );

        this.loadingRefund = false;

        if (response.data.error == "no_error") {
          this.refundDialog = false;
          this.bookingForm.booking.booking_cancellation_fee.refunded = true;
        } else {
          if (response.data.error == "invalid_refund_amount") {
            this.refundError =
              "Please enter an amount more than £0 for the refund";
          } else if (response.data.error == "invalid_refund_amount_too_large") {
            this.refundError = "Refund amount too large";
          } else {
            this.refundError = response.data.error;
          }
        }
      } catch (error) {
        console.log(error);
        this.refundError = "Unknown Error";

        this.loadingRefund = false;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.v-timeline-item {
  padding-bottom: 8px !important;
}

.v-timeline {
  padding-top: 8px !important;
}
</style>

   
